<script setup>
import { MessageCircleMoreIcon, BanIcon } from 'lucide-vue-next'
import { PrimaryButton, SecondaryButton } from '@codinglabsau/ui'
import MessageUserModal from '@/Components/Conversations/MessageUserModal.vue'
import ProfileLayout from '@/Layouts/ProfileLayout.vue'

defineProps({
  user: Object,
  claims: Object,
  existingConversationID: Number,
  achievementsCount: Number,
  unlockedAchievementsCount: Number,
  achievements: Object,
  canSuspend: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <ProfileLayout
    :user="user"
    :claims="claims"
    :achievements-count="achievementsCount"
    :unlocked-achievements-count="unlockedAchievementsCount"
    :achievements="achievements"
  >
    <template #user-actions>
      <SecondaryButton
        v-if="canSuspend && user.id !== $page.props.auth.user.id"
        class="w-full justify-center"
        :href="route('members.suspend.show', user.id)"
      >
        <BanIcon class="mr-2 size-5" />

        Suspend
      </SecondaryButton>

      <PrimaryButton
        v-if="existingConversationID || user.id === $page.props.auth.user.id"
        class="w-full justify-center"
        :href="route('messages.show', existingConversationID)"
      >
        <MessageCircleMoreIcon class="mr-2 size-5" />

        View Messages
      </PrimaryButton>

      <MessageUserModal v-else :recipient="user" trigger-class="w-full">
        <MessageCircleMoreIcon class="mr-2 size-5" />
        Message User
      </MessageUserModal>
    </template>
  </ProfileLayout>
</template>
